export const sortOptionsISelect = (options: any[]) => {
  return options.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
};
